import { render, staticRenderFns } from "./BoxPeriodicoPesquisa.vue?vue&type=template&id=1d895ab5&scoped=true"
import script from "./BoxPeriodicoPesquisa.vue?vue&type=script&lang=js"
export * from "./BoxPeriodicoPesquisa.vue?vue&type=script&lang=js"
import style0 from "./BoxPeriodicoPesquisa.vue?vue&type=style&index=0&id=1d895ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d895ab5",
  null
  
)

export default component.exports